import { Drawer, Button, Card, Row, Col } from "antd";
import Icon from "@ant-design/icons";
import { ToteIcon, PriorityIcon } from "../../assets/icons/icons";
import { useToteById } from "../../pages/common/queries";
import type { Tote } from "../../services/types";
import "./ConfirmationModal.scss";
import Styles from "../../pages/operator/op.module.scss";
import { convertUTCToLocal } from "../../utils/timeUtils";
import { getTrolleyStatus } from "../reusable/styles";

interface ToteConfirmationModalProps {
  open: boolean;
  toteId: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  toteDataOverride?: Tote | null;
}

const ToteConfirmationModal = ({
  open,
  toteId,
  onConfirm,
  onCancel,
  isLoading = false,
  toteDataOverride,
}: ToteConfirmationModalProps) => {
  const { data: fetchedToteData } = useToteById(
    toteDataOverride ? undefined : toteId
  );
  const toteData = toteDataOverride ?? fetchedToteData;

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      className="confirmation-drawer tote-modal"
      placement="bottom"
      closable={false}
      mask={true}
      height="auto"
      destroyOnClose
    >
      <div className="confirmation-content">
        <h2 className="confirmation-title">Tote Loading</h2>
        <p className="confirmation-subtitle">
          You're about to load this tote to the current trolley:
        </p>

        <div className="info-section-label">Tote Info</div>

        {toteData && (
          <Card style={{ marginBottom: "20px" }}>
            <Row justify="space-between">
              <Row gutter={15}>
                <Col
                  className={Styles.iconBox}
                  style={{ background: "#e6f3f7" }}
                >
                  <Icon component={ToteIcon} />
                </Col>
                <Col>
                  <div className="labels">Tote No</div>
                  <div className="values">{toteData?.toteNo}</div>
                </Col>
              </Row>
              <Row gutter={15} align="middle">
                {toteData?.priority && (
                  <Col
                    className={Styles.iconBox}
                    style={{ background: "#FFEBEA" }}
                  >
                    <Icon component={PriorityIcon} />
                  </Col>
                )}
              </Row>
            </Row>

            <Row style={{ marginTop: "12px" }}>
              {/* <Col span={12} className="info-item">
                <div className="labels">Weight</div>
                <div className="info-value-small">{toteData.weight}</div>
              </Col>
              <Col span={12} className="info-item">
                <div className="labels">Item count</div>
                <div className="info-value-small">{toteData.itemCount}</div>
              </Col> */}
              <Col span={12} className="info-item" style={{ marginBottom: 14 }}>
                <div className="labels">MSN</div>
                <div className="info-value-small">{toteData.msn}</div>
              </Col>
              <Col span={12} className="info-item">
                <div className="labels">USM</div>
                <div className="info-value-small">
                  {toteData.usn || toteData?.usm}
                </div>
              </Col>
              <Col span={24} style={{ marginBottom: 14 }}>
                <div className="labels">Last Scanned Location</div>
                <div
                  style={{
                    color: "#101010",
                    fontWeight: "600",
                    width: "100%",
                  }}
                >
                  {toteData.lastScannedLocation || "N/A"}
                </div>
              </Col>
              <Col span={12}>
                <div className="labels">Status</div>
                <div
                  className="info-value-small"
                  style={{
                    color: getTrolleyStatus(toteData.activityStatus),
                    fontWeight: 600,
                  }}
                >
                  {toteData.activityStatus}
                </div>
              </Col>
              <Col span={12}>
                <div className="labels">Registered Date</div>
                <div className="info-value-small" style={{ fontWeight: 600 }}>
                  {toteData.registeredDate
                    ? convertUTCToLocal(toteData.registeredDate)
                    : "N/A"}
                </div>
              </Col>
            </Row>
          </Card>
        )}

        <div className="modal-actions">
          <Button
            onClick={onCancel}
            className="cancel-button"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="confirm-button"
            loading={isLoading}
            disabled={isLoading}
          >
            Confirm Load
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default ToteConfirmationModal;
